import { HttpErrorResponse } from '@angular/common/http';
import { QueryClient } from '@tanstack/angular-query-experimental';

/**
 * Por defecto TanStack reintenta 3 veces cualquier error con espera
 * exponencial (~7 s): un 4xx o un 500 del backend (que no cambian al
 * repetirlos) dejaban la pantalla en "cargando" varios segundos antes de
 * mostrar el error. Solo se reintentan fallos transitorios: sin conexión
 * (status 0), 408, 429 y 502/503/504.
 */
const TRANSIENT_STATUS = new Set([0, 408, 429, 502, 503, 504]);
const MAX_RETRIES = 2;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (error instanceof HttpErrorResponse) return TRANSIENT_STATUS.has(error.status);
  // Errores que no son HTTP (p. ej. de programación) no se arreglan reintentando.
  return false;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetryQuery },
    },
  });
}
